import { template as template_ef595c05fb6d4e58a0a82e8478640921 } from "@ember/template-compiler";
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { LoadingIndicator } from '@cardstack/boxel-ui/components';
import { isOwnField } from '@cardstack/runtime-common';
import type { CodeRef } from '@cardstack/runtime-common/code-ref';
import type { ModuleSyntax } from '@cardstack/runtime-common/module-syntax';
import CardSchemaEditor from '@cardstack/host/components/operator-mode/card-schema-editor';
import type { CardInheritance } from '@cardstack/host/components/operator-mode/code-submode/schema-editor';
import { Divider } from '@cardstack/host/components/operator-mode/definition-container';
import { stripFileExtension } from '@cardstack/host/lib/utils';
import type { Ready } from '@cardstack/host/resources/file';
import type { Type } from '@cardstack/host/services/card-type-service';
interface Signature {
    Element: HTMLDivElement;
    Args: {
        file: Ready;
        cardInheritanceChain: CardInheritance[];
        moduleSyntax: ModuleSyntax;
        isReadOnly: boolean;
        goToDefinition: (codeRef: CodeRef | undefined, localName: string | undefined, fieldName?: string) => void;
        isLoading: boolean;
    };
}
export default class CardAdoptionChain extends Component<Signature> {
    static{
        template_ef595c05fb6d4e58a0a82e8478640921(`
    <div ...attributes>
      {{#if @isLoading}}
        <div class='loading'>
          <LoadingIndicator />
        </div>
      {{else}}
        {{#each @cardInheritanceChain as |data index|}}
          <CardSchemaEditor
            @card={{data.card}}
            @cardType={{data.cardType}}
            @file={{@file}}
            @moduleSyntax={{@moduleSyntax}}
            @childFields={{this.getFields index 'successors'}}
            @parentFields={{this.getFields index 'ancestors'}}
            @allowFieldManipulation={{this.allowFieldManipulation
              @file
              data.cardType
            }}
            @goToDefinition={{@goToDefinition}}
          />
          {{#unless (this.isLastItem index @cardInheritanceChain)}}
            <Divider @label='Inherits From' />
          {{/unless}}
        {{/each}}
      {{/if}}
    </div>
    <style scoped>
      .loading {
        display: flex;
        justify-content: center;
        margin: 30vh auto;
      }
    </style>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    isLastItem = (index: number, items: any[] = [])=>index + 1 === items.length;
    @action
    getFields(cardIndex: number, from: 'ancestors' | 'successors'): string[] {
        const children = this.args.cardInheritanceChain.filter((_data, index)=>from === 'ancestors' ? index > cardIndex : index < cardIndex);
        const fields = children.reduce((result: string[], data)=>{
            return result.concat(data.cardType.fields.filter((field)=>isOwnField(data.card, field.name)).map((field)=>field.name));
        }, []);
        return fields;
    }
    @action
    allowFieldManipulation(file: Ready, cardType: Type): boolean {
        if (this.args.isReadOnly) {
            return false;
        }
        // Only allow add/edit/remove for fields from the currently opened module
        return stripFileExtension(file.url) === cardType.module;
    }
}
